export const DEFAULT_TUNING = {
	// Input / time
	inputDeadzone: 0.25,
	slowmoMin: 0.35,
	slowmoMax: 1,
	slowmoDownMultiplier: 0.65,

	// Player
	playerSize: 48,
	playerSpeed: 260,
	gravity: 900,
	moveMinScale: 0.6,
	playerMaxHealth: 3,

	// Jump
	jumpForce: 720,
	jumpInputThreshold: -0.45,
	jumpMagThreshold: 0.5,
	jumpInitialScale: 0.55,
	jumpHoldForce: 900,
	jumpChargeMin: 0.12,
	jumpChargeMax: 0.6,

	// Dash (Celeste-like)
	dashEnabled: true,
	dashSpeed: 900,
	dashDuration: 0.12,
	dashCooldown: 0.8,
	dashSwipeMinDistancePx: 60,
	dashSwipeMaxTime: 0.22,

	// Down drop (stick down = faster fall toward nearest platform)
	downDropEnabled: true,
	downDropInputThreshold: 0.45,
	downDropTimeToPlatform: 0.18,
	downDropMaxSpeed: 500,
	downDropGravityScale: 1.5,

	// Drop through platform (when grounded and stick strongly down)
	platformDropEnabled: true,
	platformDropInputThreshold: 0.9,
	platformDropHoldDuration: 0.14,
	platformDropIgnoreDuration: 0.18,
	platformDropKickSpeed: 120,

	// Ledge
	ledgeGrabEnabled: false,
	ledgeGrabMargin: 46,
	ledgeGrabMaxUpSpeed: 120,
	ledgePullSpeed: 170,
	ledgeJumpLock: 0.25,

	// Wall run
	wallRunEnabled: true,
	wallRunMargin: 10,
	wallRunMaxTime: 1.2,
	wallRunMaxAscent: 260,
	wallRunRegrabLock: 0.18,
	wallRunInputXMin: 0.35,
	wallRunUpInputThreshold: -0.25,
	wallRunGravityScale: 0.25,
	wallRunMaxFallSpeed: 120,
	wallRunUpAccel: 900,
	wallJumpInputAwayMin: 0.25,
	wallJumpXSpeed: 420,
	wallJumpYScale: 0.9,

	// Platform generation
	platformHeight: 10,
	platformDefaultBottom: 250,
	platformMinSideOffset: 24,
	platformWidthRatio: 0.7,
	platformMinWidth: 120,
	platformMaxWidth: 220,
	platformGapMin: 120,
	platformGapMax: 220,
	platformCleanupBelow: 320,
	cameraFollowThreshold: 420,
	cameraDownFollowEnabled: true,
	cameraDownFollowThreshold: 220,
	cameraDownFollowMax: 260,
	cameraSpawnAhead: 640,

	// Platform destruction
	platformDestructionEnabled: true,
	platformSplitGap: 15,
	platformMinPieceWidth: 30,
	explosionDuration: 0.22,
	explosionRadius: 26,

	// Enemies
	enemySpawnAhead: 520,
	enemyGapMin: 260,
	enemyGapMax: 420,
	enemyMarginX: 48,
	enemySize: 32,
	enemyCooldownMin: 1.3,
	enemyCooldownMax: 2.4,
	enemiesOnlyShootInView: true,

	// Enemy AI (movement / dodge / line-of-sight)
	enemyMoveEnabled: true,
	enemyMoveSpeed: 150,
	enemyMoveAccel: 300,
	enemyWanderStrength: 0.35, // 0..1, adds gentle side sway so enemies don't move in a straight line
	enemyWanderFreq: 0.8,

	enemyDodgeEnabled: true,
	enemyDodgeLookahead: 0.25,
	enemyDodgePadding: 10,
	enemyDodgeStrength: 0.5,

	enemyLosEnabled: true,
	enemyLosMargin: 6,
	enemyLosRepathInterval: 0.18,
	enemyLosSearchStep: 36,
	enemyLosSearchMax: 240,

	// Enemy burst fire (when LOS is regained / optimal trajectory)
	enemyBurstEnabled: true,
	enemyBurstCountMin: 2,
	enemyBurstCountMax: 4,
	enemyBurstInterval: 0.08,
	enemyBurstSpreadDeg: 6,

	// Projectiles (enemy)
	projectileSpeed: 340,
	projectileLifetime: 6,
	projectileSize: 10,
	projectilePlayerDamage: 1,

	// Projectiles (player)
	playerProjectileSpeed: 800,
	playerProjectileLifetime: 2.5,
	playerProjectileSize: 10,

	// Ammo / reload
	playerReloadDuration: 1.1,
	enemyReloadDuration: 1.3,

	// Melee
	meleeRadius: 56,
	meleeCooldown: 0.12,

	// Time boost
	timeBoostDuration: 0.22,
	timeBoostFireValue: 1,
	timeBoostMeleeValue: 1,
	timeBoostDashValue: 1,
	timeBoostDashDuration: 0.18,
	timeBoostLedgeValue: 1,
	timeBoostLedgeDuration: 0.28
};

export type Tuning = typeof DEFAULT_TUNING;

export function clamp01(value: number) {
	return Math.min(Math.max(value, 0), 1);
}
